module.exports = __webpack_public_path__ + "static/media/login-logo.da7564c4.png";